<template>
    <div>
        <table class="table table-bordered">
            <thead>
            <tr>
                <th v-if="phoneTypes">Type</th>
                <th>Phone #</th>
                <th class="w-50s">Primary</th>
                <th class="w-50s"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(n, ind) in data.values.length">
                <!-- Phone Type Select -->
                <td v-if="phoneTypes">
                    <select :name="name + `[` + ind + `][type]`" class="form-control" v-model="data.values[ind].type" required>
                        <option v-for="(value, name) in phoneTypes" :value="name">{{ value }}</option>
                    </select>
                </td>
                <!-- Phone Number -->
                <td>

                    <div class="input-group">
                        <span class="input-group-addon">
                            <i class="fa fa-fw" :class="data.inputGroup['addon_icon'] || 'fa-phone'"/>
                            {{ data.inputGroup['addon_content'] || '' }}
                        </span>
                        <input type="text" class="form-control"
                               :name="name + `[` + ind + `][phone]`"
                               v-model="data.values[ind].phone"
                               :placeholder="phonePlaceholder"
                               v-mask="phoneMask">
                    </div>
                </td>
                <!-- Is Primary -->
                <td class="text-center">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" class="mr-n3" :name="name + `[` + ind + `][is_primary]`" value="1"
                             :checked="data.values[ind].is_primary" @change="setPrimary(ind)">
                    </label>
                  </div>
                </td>
                <td>
                    <a class="btn btn-danger" @click="removeLine($event, ind)"><i class="fa fa-trash"/></a>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="no-results-text" v-if="data.values.length === 0">No results</span>
                </td>
                <td>
                    <a id="add-line" class="btn btn-primary" @click="addLine"><i class="fa fa-plus"/></a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
    table {
        margin-bottom: 10px;
    }
</style>

<script>

  /**
   *
   * Component used in bsphones Form widget, represent dynamic phones form.
   *
   *
   *
   * Example:
   *
   * <bs-phones name="contact_phone"
   *            input-group-json="{'addon_icon': 'fa-phone'}"
   *            value-json="[{'phone': '1112223344', 'type': 'cell', 'is_primary': true}, ...]"
   *            phone-mask-json="{'mask': '(9{3}) 9{3}-9{4}[ ext. 9{1,10}]', 'greedy' : false}"
   *            phone-placeholder="(999) 999-9999"
   *            phone-types-json="['cell', 'home']">
   * </bs-phones>
   *
   */
  export default {

    props: {
      // Field name.
      name: {
        type: String,
        required: true
      },
      /**
       * Initial phones array,
       * should contain 'type' and 'phone' fields; 'is_primary' optional.
       */
      modelValue: {
        type: Array,
        default: () => {return [];}
      },
      // Initial input-group object.
      inputGroup: {
        type: Object,
        default: () => {return {};}
      },
      // Phone types array.
      phoneTypes: {
        type: Object
      },
      // Phone mask
      phoneMask: {
        type: Object,
        default: null
      },
      // Phone placeholder
      phonePlaceholder: {
        type: String,
        default: null
      },
    },

    mounted() {
    },

    data() {
      return {
        data: {
          // Input group contains input field addon icon and content.
          inputGroup: this.inputGroup,
          // Array with phone objects, contains 'phone', 'type' and 'is_primary' fields.
          values: this.modelValue,
        }
      };
    },

    methods: {
      /**
       * Add new phone row.
       * @param event
       */
      addLine(event) {
        event.preventDefault();

        this.data.values.push({
          type: '',
          number: '',
          is_primary: false,
        })
      },

      /**
       * Add new phone row.
       * @param event
       * @param index
       */
      removeLine(event, index) {
        event.preventDefault();
        this.data.values.splice(index, 1);
      },

      /**
       * Set primary phone with specified row index.
       * @param index
       */
      setPrimary(index) {
        this.data.values.forEach((item) => {item.is_primary = false});
        this.data.values[index].is_primary = true;
      }
    },

    computed: {}
  }
</script>
